<div class="p-col-12 p-col-nopad alert-message alert-message-box">
  <div class="p-col-3 p-col-nopad alert-message alert-message-key">
    <div class="p-col-3 p-col-nopad alert-message alert-message-key-icon">
      <mat-icon>{{alertMessage.iconClassName}}</mat-icon>
    </div>
    <div class="p-col-9 p-col-nopad alert-message alert-message-key alert-message-key-time">
      <span *ngIf="isRecent()" class="alert-message alert-message-key alert-message-key-time-recent">{{alertMessage.time | date:'shortTime'}}</span>
      <span *ngIf="isLate()" class="alert-message alert-message-key alert-message-key-time-late">{{alertMessage.time | date:'shortTime'}}</span>
      <span *ngIf="isReallyLate()" class="alert-message alert-message-key alert-message-key-time-really-late">{{alertMessage.time | date:'shortTime'}}</span>
    </div>
    <div class="p-col-9 p-col-nopad alert-message alert-message-key alert-message-key-ago">
      <span *ngIf="isRecent()" class="alert-message alert-message-key alert-message-key-ago-recent">{{ago()}}</span>
      <span *ngIf="isLate()" class="alert-message alert-message-key alert-message-key-ago-late">{{ago()}}</span>
      <span *ngIf="isReallyLate()" class="alert-message alert-message-key alert-message-key-ago-really-late">{{ago()}}</span>
    </div>
  </div>
  <div class="p-col-9 p-col-nopad alert-message alert-message-body">
    <div class="p-col-12 p-col-nopad alert-message alert-message-body">
      <span class="alert-message alert-message-body alert-message-body-title">{{ alertMessage.title }}</span>
    </div>
    <div class="p-col-12 p-col-nopad alert-message alert-message-body ">
      <span class="alert-message alert-message-body alert-message-body-message">{{ alertMessage.message }}</span>
    </div>
    <div [hidden]="true" class="p-col-12 p-col-nopad alert-message alert-message-body ">
      <span class="alert-message alert-message-body alert-message-body-extra">{{ alertMessage.extra }}</span>
    </div>
  </div>
</div>